import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

const RESERVATION_DETAILS_RVS = gql`
  mutation reservationDetailsSMS($input: AssignmentsSMSInput) {
    reservationDetailsSMS(input: $input) {
      success
    }
  }
`;

export const withReservationDetailsSMS = graphql(RESERVATION_DETAILS_RVS, {
  props: ({ mutate }) => ({
    reservationDetailsSMS: input => mutate({ variables: { input } })
  })
});

export default withReservationDetailsSMS;
